import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQuery,
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    authenticateUser: builder.mutation({
      query: (payload) => ({
        url: '/authenticate',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'authenticateUser'
        );
      },
    }),

    forgotAuthPassword: builder.mutation({
      query: (payload) => ({
        url: '/request',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'forgotAuthPassword'
        );
      },
    }),

    twoFactorVerify: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'twoFactorVerify');
      },
    }),

    resetAuthPassword: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'resetAuthPassword'
        );
      },
    }),

    twoFactorSetup: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'twoFactorSetup');
      },
    }),

    twoFactorSignup: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'twoFactorSignup');
      },
    }),

    getTwoFactorResetCode: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getTwoFactorResetCode'
        );
      },
    }),

    resetTwoFactorResetCode: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'resetTwoFactorResetCode'
        );
      },
    }),

    logOut: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'logOut');
      },
    }),
  }),
});

export const {
  useAuthenticateUserMutation,
  useForgotAuthPasswordMutation,
  useTwoFactorVerifyMutation,
  useResetAuthPasswordMutation,
  useTwoFactorSetupMutation,
  useTwoFactorSignupMutation,
  useLogOutMutation,
  useGetTwoFactorResetCodeMutation,
  useResetTwoFactorResetCodeMutation,
} = authApi;
